export const mockData = {
  success: true,
  data: [
    {
      id: 187,
      token: "V1rbKmpdLDHeOlyIDrwKEzRMP5wKpW",
      owner_id: 1,
      name: "Testing Form",
      description: "<p>Lorem descriptionn</p>",
      is_internal: 0,
      queue_caption: null,
      queue_type_caption: null,
      initails_email_response: "Hello",
      start_date: null,
      end_date: null,
      create_time: "2022-03-03 11:40:48",
      is_active: 1,
      update_time: "2022-03-03 11:50:04",
      enable_file_attachment: 1,
      file_attachment_label: null,
      form_fields: [
        {
          field_label: "Section Title One",
          field_type: "sect-title",
        },
        {
          field_label: "Text Field",
          field_type: "input",
          is_required: "false",
        },
        {
          field_label: "Text Area",
          field_type: "textarea",
          characters_range: {
            min: 0,
            max: 12000,
          },
          is_required: "false",
        },
        {
          field_label: "Contact",
          field_items: [
            {
              field_label: "title",
              field_type: "input",
            },
            {
              field_label: "first_name",
              field_type: "input",
            },
            {
              field_label: "last_name",
              field_type: "input",
            },
            {
              field_label: "phone_number",
              field_type: "number",
            },
            {
              field_label: "email_address",
              field_type: "input",
            },
          ],
          field_type: "contact",
          is_required: "false",
        },
        {
          field_label: "Address",
          field_items: [
            {
              field_label: "house_no",
              field_type: "number",
            },
            {
              field_label: "street",
              field_type: "input",
            },
            {
              field_label: "address_line_2",
              field_type: "input",
            },
            {
              field_label: "country",
              field_type: "dropdown",
            },
            {
              field_label: "state",
              field_type: "dropdown",
            },
            {
              field_label: "city",
              field_type: "input",
            },
            {
              field_label: "postal/zip code",
              field_type: "number",
            },
          ],
          field_type: "address",
          is_required: "false",
        },
        {
          field_label: "Organization",
          field_items: [
            {
              field_label: "company_name",
              field_type: "input",
            },
            {
              field_label: "house_no",
              field_type: "number",
            },
            {
              field_label: "street",
              field_type: "input",
            },
            {
              field_label: "address_line_2",
              field_type: "input",
            },
            {
              field_label: "country",
              field_type: "dropdown",
            },
            {
              field_label: "state",
              field_type: "dropdown",
            },
            {
              field_label: "city",
              field_type: "input",
            },
            {
              field_label: "postal/zip code",
              field_type: "number",
            },
            {
              field_label: "title",
              field_type: "input",
              is_required: "true",
            },
            {
              field_label: "first_name",
              field_type: "input",
            },
            {
              field_label: "last_name",
              field_type: "input",
            },
            {
              field_label: "phone_number",
              field_type: "number",
            },
            {
              field_label: "email_address",
              field_type: "input",
            },
            {
              field_label: "Attach File",
              allowed_types: [
                {
                  value: "jpg",
                },
                {
                  value: "txt",
                },
                {
                  value: "doc",
                },
                {
                  value: "pdf",
                },
                {
                  value: "xlm",
                },
              ],
              file_size: {
                min_value: "",
                min_value_unit: "KB",
                max_value: "1200",
                max_value_unit: "MB",
              },
              field_type: "file",
              is_required: "true",
            },
          ],
          field_type: "organization",
          is_required: "false",
        },
        {
          field_label: "Dropdown",
          field_items: ["Option 1", "Option 2"],
          field_type: "dropdown",
          is_required: "false",
        },
        {
          field_label: "Check Box",
          field_items: ["Option 1", "Option 2"],
          field_type: "checkbox",
          is_required: "true",
        },
        {
          field_label: "Radio",
          field_items: ["Option 1", "Option 2"],
          field_type: "radio",
          is_required: "false",
        },
        {
          field_label: "Attach File",
          allowed_types: [
            {
              value: "jpg",
            },
            {
              value: "txt",
            },
            {
              value: "doc",
            },
            {
              value: "pdf",
            },
            {
              value: "xlm",
            },
          ],
          file_size: {
            min_value: "",
            min_value_unit: "KB",
            max_value: "1200",
            max_value_unit: "MB",
          },
          field_type: "file",
          is_required: "true",
        },
        {
          field_label: "Date",
          field_type: "date",
          is_required: "false",
        },
        {
          field_label: "Number",
          field_type: "number",
          is_required: "false",
        },
        {
          field_label: "Currency",
          field_type: "currency",
          currency: "GBP",
          is_required: "false",
        },
      ],
      queues: [
        {
          id: "64",
          name: "HR and admin",
        },
      ],
      queueTypes: [
        {
          id: "73",
          name: "Welfare",
        },
      ],
      banner_link:
        "https://wfm-saas.s3.eu-west-1.amazonaws.com/webform/banner/1646304048~10028~images.jpeg",
      policy_document_link: null,
      created_by: "Andrew  Blakes",
      updated_by: "Andrew  Blakes",
      merchant_name: "Blakes & Shawn",
      fields: [
        {
          fieldName: "Eniola_Test",
          fieldType: "textbox",
          is_requred: true,
        },
      ],
    },
  ],
  _links: {
    self: {
      // href: "https://bedc-wfm-staging.convergenceondemand.net/wfmservice/web-forms?filter%5Bname%5D=Testing+Form&page=1",
      href: "http://api.cicodsaadev.com/wfmservice/web-forms?filter%5Bname%5D=Testing+Form&page=1",
    },
  },
  _meta: {
    totalCount: 1,
    pageCount: 1,
    currentPage: 1,
    perPage: 20,
  },
};
